export default __webpack_public_path__ + "static/media/stairsToSuccess.30a00714.jpg";